import { render } from "./Consulting.vue?vue&type=template&id=28c6bc5a&scoped=true"
import script from "./Consulting.vue?vue&type=script&lang=js"
export * from "./Consulting.vue?vue&type=script&lang=js"

import "./Consulting.vue?vue&type=style&index=0&id=28c6bc5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c6bc5a"]])

export default __exports__